import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {ToolTip} from 'components';

import DashboardApi from 'api/dashboard';

import {Row, Col} from 'components';
import DataTable from 'components/dataTable';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {makeCancelable} from 'helpers/cancelablePromise';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

function displayValue(val) {
  return val || val === 0 ? val : '-';
}

function displayPercent(val, denum) {
  if ((val || val === 0) && !!denum) {
    return Math.round(val / denum * 100) + '%';
  }
  return '-';
}

const widths = ['70%', '15%', '15%'];

class DataCleanup extends Component {
  static propTypes = {
    className: PropTypes.string,
    intl: intlShape.isRequired,
    getTruBlue: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  };

  constructor(props) {
    super(props);

    this.state = {
      results: {},
    };
  }

  componentWillMount() {
    this.getData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.branch !== this.props.branch) {
      this.getData(nextProps);
    }
  }

  componentWillUnmount() {
    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }
  }

  getData = (props = this.props) => {
    let branches = props.branch === -1 ? props.branches : [props.branch];

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }

    (this.fetching = makeCancelable(DashboardApi.getDataQuality(props.getTruBlue, branches)))
      .then(rpt => {
        this.setState({
          results: rpt,
        });
      })
      .catch(err => {
        console.error(err);
      });
  };

  render() {
    let {results} = this.state;

    let title;
    let truBlueTable = '';

    let {formatMessage} = this.props.intl;

    if (this.props.title) {
      title = this.props.title;
    } else {
      title = <h3><FormattedMessage id='posdashboard.summary.data.quality'/>
        <ToolTip title={formatMessage({id: 'posdashboard.summary.data.tooltip'})}
                 topLeft
                 iconOnly/>
      </h3>;
    }

    if (this.props.getTruBlue && results) {
      truBlueTable = <DataTable style={{marginBottom: 0}}
                                headerRow={[formatMessage({id: 'posdashboard.summary.trublue.systems'}), undefined, undefined]}
                                widths={widths}
                                className='table-biolab container-margin-top'
                                data={[
                                  [
                                    formatMessage({id: 'posdashboard.summary.trublue.total'}),
                                    displayValue(results.totalTrueBlue),
                                    undefined,
                                  ],
                                  [
                                    formatMessage({id: 'posdashboard.summary.trublue.active'}),
                                    displayValue(results.activeTrueBlue),
                                    displayPercent(results.activeTrueBlue, results.totalTrueBlue),
                                  ],
                                  [
                                    formatMessage({id: 'posdashboard.summary.trublue.inactive'}),
                                    displayValue(results.inactiveTrueBlue),
                                    displayPercent(results.inactiveTrueBlue, results.totalTrueBlue),
                                  ],
                                  [
                                    formatMessage({id: 'posdashboard.summary.trublue.eligible'}),
                                    displayValue(results.eligibleTrueBlue),
                                    displayPercent(results.eligibleTrueBlue),
                                  ],
                                  [
                                    formatMessage({id: 'posdashboard.summary.trublue.opportunity'}),
                                    displayValue(results.opportunityTrueBlue),
                                    displayPercent(results.opportunityTrueBlue),
                                  ],
                                  [
                                    formatMessage({id: 'posdashboard.summary.trublue.ineligible'}),
                                    displayValue(results.ineligibleTrueBlue),
                                    displayPercent(results.ineligibleTrueBlue),
                                  ],
                                ]}/>;
    }

    return <div className='data-cleanup-tile expanded-tile'>
      {title}
      <div className={this.props.className}>

        <div className='chart-body'
             style={{minHeight: 'inherit', padding: 0, background: 'white'}}>
          <Row>
            <Col md={6}>
              <DataTable style={{marginBottom: 0}}
                         headerRow={[formatMessage({id: 'general.accounts'}), undefined, undefined]}
                         widths={widths}
                         className='table-biolab'
                         data={[
                           [
                             formatMessage({id: 'general.total.accounts'}),
                             displayValue(results.customers),
                             undefined,
                           ],
                           [
                             formatMessage({id: 'general.active.accounts'}),
                             displayValue(results.activeCustomers),
                             displayPercent(results.activeCustomers, results.customers),
                           ],
                           [
                             formatMessage({id: 'general.inactive.accounts'}),
                             displayValue(results.inactiveCustomers),
                             displayPercent(results.inactiveCustomers, results.customers),
                           ],
                         ]}/>
            </Col>

            <Col md={6}>
              <DataTable style={{marginBottom: 0}}
                         headerRow={[formatMessage({id: 'posdashboard.summary.account.contacts'}), undefined, undefined]}
                         widths={widths}
                         className='table-biolab'
                         data={[
                           [
                             formatMessage({id: 'posdashboard.summary.total.contacts'}),
                             displayValue(results.activeContacts),
                             undefined,
                           ],
                           [
                             formatMessage({id: 'posdashboard.summary.contacts.phone'}),
                             displayValue(results.activePhoneNumbers),
                             displayPercent(results.activePhoneNumbers, results.activeContacts),
                           ],
                           [
                             formatMessage({id: 'posdashboard.summary.contacts.email'}),
                             displayValue(results.activeEmails),
                             displayPercent(results.activeEmails, results.activeContacts),
                           ],
                         ]}/>
            </Col>
          </Row>
          <Row style={{marginTop: 20}}>
            <Col md={6}>
              <DataTable style={{marginBottom: 0}}
                         headerRow={[formatMessage({id: 'posdashboard.summary.account.details'}), undefined, undefined]}
                         widths={widths}
                         className='table-biolab'
                         data={[
                           [
                             formatMessage({id: 'general.total.accounts'}),
                             displayValue(results.customers),
                             undefined,
                           ],
                           [
                             formatMessage({id: 'posdashboard.summary.accounts.verified'}),
                             displayValue(results.activeVerifiedAddresses), // None of these are actually active numbers for this section; variables names are out of date
                             displayPercent(results.activeVerifiedAddresses, results.customers),
                           ],
                           [
                             formatMessage({id: 'posdashboard.summary.single.contact'}),
                             displayValue(results.activeSingleContact),
                             displayPercent(results.activeSingleContact, results.customers),
                           ],
                           [
                             formatMessage({id: 'posdashboard.summary.multiple.contacts'}),
                             displayValue(results.activeMultipleContacts),
                             displayPercent(results.activeMultipleContacts, results.customers),
                           ],
                           [
                             formatMessage({id: 'posdashboard.summary.single.system'}),
                             displayValue(results.activeSingleSystem),
                             displayPercent(results.activeSingleSystem, results.customers),
                           ],
                           [
                             formatMessage({id: 'posdashboard.summary.multiple.systems'}),
                             displayValue(results.activeMultipleSystems),
                             displayPercent(results.activeMultipleSystems, results.customers),
                           ],
                           [
                             formatMessage({id: 'posdashboard.summary.accounts.email'}),
                             displayValue(results.accountsWithEmail),
                             displayPercent(results.accountsWithEmail, results.customers),
                           ],
                         ]}/>
            </Col>

            <Col md={6}>
              <DataTable style={{marginBottom: 0}}
                         headerRow={[formatMessage({id: 'general.system'}), undefined, undefined]}
                         widths={widths}
                         className='table-biolab'
                         data={[
                           [
                             formatMessage({id: 'general.total.systems'}),
                             displayValue(results.systems),
                             undefined,
                           ],
                           [
                             formatMessage({id: 'posdashboard.summary.total.spas'}),
                             displayValue(results.spas),
                             displayPercent(results.spas, results.systems),
                           ],
                           [
                             formatMessage({id: 'posdashboard.summary.total.swimspas'}),
                             displayValue(results.swimSpas),
                             displayPercent(results.swimSpas, results.systems),
                           ],
                           [
                             formatMessage({id: 'general.total.pools'}),
                             displayValue(results.pools),
                             displayPercent(results.pools, results.systems),
                           ],
                         ]}/>

              {truBlueTable}
            </Col>
          </Row>
        </div>
      </div>
    </div>;
  }
}

export default injectIntl(bindLocaleUpdate(DataCleanup));
